module.exports = __webpack_public_path__ + "static/media/Graveler_gaussian2.a0854dac.png";